import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./WelcomePopup.css";

const WelcomePopup = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

 useEffect(() => {
  const hasSeenPopup = localStorage.getItem("welcomePopupSeen");

  if (!hasSeenPopup) {
    const timer = setTimeout(() => {
      setShow(true);
    }, 3000); // ⏱️ 3 seconds delay

    return () => clearTimeout(timer);
  }
}, []);


  const closePopup = () => {
    setShow(false);
    localStorage.setItem("welcomePopupSeen", "true");
  };

  const handleOrderNow = () => {
    closePopup();
    navigate("/order-online");
  };

  if (!show) return null;

  return (
    <div className="welcome-overlay">
      <div className="welcome-popup">
        <button className="welcome-close" onClick={closePopup}>
          &times;
        </button>

        <p>
          Welcome to our brand new, easier to use website.
        </p>

        <button className="order-now-btn" onClick={handleOrderNow}>
          Order Now
        </button>
      </div>
    </div>
  );
};

export default WelcomePopup;
